/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { getSVGIconForFile } from "cms/documents/document/helpers";
import { formatBytes } from "utils/format-bytes";

const DocumentUploadItem = (props) => {
    
    const { file } = props || {};
    
    return (
        <Fragment>
            <div className='document-upload-item' key={file.name} >
                <div style={{ width: "36px", height: "36px", margin: "16px", minHeight: "36px" }}>
                    {getSVGIconForFile(file)}
                </div>
                <div style={{}}>
                    <div>{file.name}</div>
                    <div>Size: {formatBytes(file.size)}</div>
                </div>
            </div>
    
        </Fragment>
    );
};

export { DocumentUploadItem };
